import React from "react";
import { Link } from "react-router-dom";
import { BookOpen, HelpCircle, ShieldCheck, Mail, LogIn, UserPlus, Download, FileText } from "lucide-react";

/**
 * Tiny "Resources" footer used on every public-facing auth screen
 * (Login, Register, accept-invite, forgot/reset password) and inside the
 * landing page footer.
 *
 * Kept deliberately understated so it doesn't compete with the primary
 * call-to-action above. Always shown — even when the user is mid-flow —
 * so the legal terms are one click away at the moment of decision.
 *
 * The two auth links (Sign in / Create account) exist primarily for SEO
 * internal-linking (Semrush Feb 2026 flagged /register and /forgot-password
 * as having only one inbound link). Keeping them small and secondary.
 */
export default function ResourcesFooter() {
  return (
    <div
      className="mt-6 pt-4 text-xs text-center muted-text"
      style={{ borderTop: "1px solid #1f1f1f" }}
      data-testid="resources-footer"
    >
      <div className="uppercase tracking-wider mb-2 flex items-center justify-center gap-1.5">
        <BookOpen size={11} /> Resources
      </div>
      <div className="flex items-center justify-center gap-4 flex-wrap">
        <Link
          to="/terms"
          className="hover:text-amber-400 inline-flex items-center gap-1"
          data-testid="resources-terms-link"
        >
          <ShieldCheck size={12} /> Terms &amp; Conditions
        </Link>
        <Link
          to="/faq"
          className="hover:text-amber-400 inline-flex items-center gap-1"
          data-testid="resources-faq-link"
        >
          <HelpCircle size={12} /> FAQ
        </Link>
        <a
          href="/user-manual.pdf"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-amber-400 inline-flex items-center gap-1"
          data-testid="resources-manual-link"
        >
          <Download size={12} /> User Manual (PDF)
        </a>
        <Link
          to="/blog"
          className="hover:text-amber-400 inline-flex items-center gap-1"
          data-testid="resources-blog-link"
        >
          <FileText size={12} /> Blog
        </Link>
        <Link
          to="/login"
          className="hover:text-amber-400 inline-flex items-center gap-1"
          data-testid="resources-signin-link"
        >
          <LogIn size={12} /> Sign in
        </Link>
        <Link
          to="/register"
          className="hover:text-amber-400 inline-flex items-center gap-1"
          data-testid="resources-register-link"
        >
          <UserPlus size={12} /> Create account
        </Link>
        <a
          href="mailto:mail@cameraclubscore.com"
          className="hover:text-amber-400 inline-flex items-center gap-1"
          data-testid="resources-contact-link"
        >
          <Mail size={12} /> Contact us
        </a>
      </div>
    </div>
  );
}
